var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Dialog as MuiDialog } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import theme from '../theme';
var Dialog = function (props) {
    return (_jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsxs(MuiDialog, __assign({ open: props.isOpen, onClose: props.events.onClose }, props.dialogProps, { children: [_jsxs(DialogTitle, __assign({ style: {} }, { children: [props.components.title && props.components.title(__assign({}, props)), props.components.closeIcon && _jsx(IconButton, __assign({ "aria-label": "close", onClick: props.events.onClose, sx: {
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: "var(--palette-secondary-light)"
                            } }, { children: _jsx(CloseIcon, {}) }))] })), _jsx(DialogContent, { children: props.components.content && props.components.content(__assign({}, props)) }), props.components.actions && _jsx(DialogActions, { children: props.components.actions && props.components.actions(__assign({}, props)) })] })) })));
};
export default Dialog;
